import AddressAutoComplete from "../admin_controllers/address_auto_complete"
import autocomplete from "../lib/autocomplete"

const TOUR_DATA_DESC = {
    [1]: "旅游城市",
    [2]: "景点",
    [4]: "美食特产",
    [13]: "路书",
    [19]: "观景台",
    [23]: "旅游服务区",
    [30]: "自驾营地",
    [32]: "导游词",
    [34]: "解说点",
}

export default class extends ApplicationController {
    static targets = ["mapWidget", "address", "name"]
    static values = { dataSource: Object, dataType: Number, dataFiltered: Boolean }

    connect() {
        this.initMap()
        this.initMarker()
        this.initAutocomplete()
        this.initData()
        this.initPointsSimplifier()
        this.initTitle()
    }

    initMap() {
        const mapOptions = {
            zoom: 16,
            doubleClickZoom: false,
        }

        this.map = new AMap.Map(this.mapWidgetTarget, mapOptions)
        this.map.addControl(new AMap.Scale());
    }

    initAutocomplete() {
        this.addressAutoComplete = new AddressAutoComplete(this.addressTarget, (item) => {
            this.addressTarget.value = item.label
            this.setMarker(item.location.lng, item.location.lat)
        })

        autocomplete({
            minLength: 1,
            preventSubmit: true,
            input: this.nameTarget,
            className: 'auto-complete',
            attachedClassName: 'auto-complete-name-container',
            emptyMsg: '该名称没有找到',
            debounceWaitMs: 200,
            fetch: (text, update) => {
                this.fetchData(`/tour_data_map_view/data_list?data_types=${this.getQueryedDataTypes()}&name=${text}`, (jsonResult) => {
                    update(jsonResult)
                })
            },
            render: (item, currentValue) => {
                let div = document.createElement('div')
                div.innerHTML = `${item.name}<span>${TOUR_DATA_DESC[item.dataType]}</span>`
                return div
            },
            onSelect: (item) => {
                this.nameTarget.value = item.name
                this.onAutocompleteSelect(item)
            }
        })
    }

    initMarker() {
        // Init address marker, use svg marker
        AMapUI.loadUI(['overlay/SvgMarker'], (SvgMarker) => {
            const shape = new SvgMarker.Shape.RectangleFlagPin({
                height: 30,
                fillColor: '#1791FC',
                strokeWidth: 1,
                strokeColor: '#666'
            })

            this.marker = new SvgMarker(shape, {
                showPositionPoint: true,
            })
        })
    }

    setMarker(lng, lat) {
        if (this.marker) {
            const lnglat = [lng, lat]

            this.marker.setPosition(lnglat)

            if (!this.marker.getMap()) {
                this.marker.setMap(this.map)
            }

            this.map.setCenter(lnglat)
        }
    }

    initPointsSimplifier() {
        AMapUI.load(['ui/misc/PointSimplifier'], (PointsSimplifier) => {
            if (!PointsSimplifier.supportCanvas) {
                alert('当前环境不支持 Canvas！')
                return
            }

            let [renderConstructor, renderOptions] = this.getRenderOptions(PointsSimplifier)

            this.pointsSimplifier = new PointsSimplifier({
                map: this.map,
                compareDataItem: function(a, b, aIndex, bIndex) {
                    return aIndex > bIndex ? -1 : 1;
                },
                getPosition: function(dataItem) {
                    return dataItem.position;
                },
                getHoverTitle: (dataItem, index) => {
                    return this.getHoverTitle(dataItem)
                },
                renderConstructor: renderConstructor,
                renderOptions: renderOptions,
            })

            this.pointsSimplifier.setData(this.dataSource);

            this.pointsSimplifier.on('pointClick', (event, record) => {
                this.showDialogWithData(this.dataTypeValue, record.data)
            })

            this.onPointsSimplifierLoad()
        })
    }

    initData() {
        this.dataSource = this.dataSourceValue["data"]
    }

    initTitle() {
        this.titleElement = document.querySelector("#tour-data-map-view-title")
        this.setTitleWithData(this.dataSource)
    }

    showDialogWithData(dataType, data) {
        this.showLoading(true)

        this.fetchData(`/tour_data_map_view/show_info?data_type=${dataType}&id=${data.id}`, (jsonResult) => {
            this.fetchData(jsonResult.url, (response) => {
                const a = document.createElement('a')

                a.target= '_blank'
                a.href= jsonResult.url
                a.click()

                this.showLoading(false)
            })
        })
    }

    fetchData(url, callback) {
        fetch(url).then(response => {
            return response.json()
        }).then((jsonResult) => {
            callback(jsonResult)
        }).catch(err => {
            console.error(`fetchData调用出错: ${err}`)
            this.showLoading(false)
        })
    }

    showLoading(isShow) {
        if (isShow) {
            this.loadingElement = document.createElement("div")
            this.loadingElement.classList.add("is-overlay", "is-flex", "is-justify-content-center", "is-align-items-center")

            const loadingButton = document.createElement("button")
            loadingButton.classList.add("button", "is-primary", "is-rounded", "is-loading")
            this.loadingElement.appendChild(loadingButton)

            this.element.appendChild(this.loadingElement)
        } else {
            if (this.loadingElement) {
                this.element.removeChild(this.loadingElement)
                this.loadingElement = null
            }
        }
    }

    onAutocompleteSelect(item) {
        if (item.position && item.position.length === 2) {
            const index = this.dataSource.findIndex(data => data.id === item.id)

            if (index === -1) {
                this.dataSource.push(item)
                this.pointsSimplifier.setData(this.dataSource)
                this.setTitleWithData(this.dataSource)
            }

            this.setMarker(item.position[0], item.position[1])
        }
    }

    // Subclass should implement
    onPointsSimplifierLoad() {
    }

    setTitleWithData(dataSource) {
        this.titleElement.innerText = `共${dataSource.length}个点`
    }

    getHoverTitle(dataItem) {
        return dataItem.title
    }

    getRenderOptions(PointsSimplifier) {
        const renderConstructor = PointsSimplifier.Render.Canvas
        const renderOptions = { pointStyle: { fillStyle: "#ff1800" } }

        return [renderConstructor, renderOptions]
    }

    getQueryedDataTypes() {
        return this.dataTypeValue
    }
}